export class NotImplementedError extends Error {
  // eslint-disable-next-line unicorn/custom-error-definition
  public constructor(message?: string) {
    super(message)
    this.name = 'NotImplementedError'
  }
}

export class ValidationError extends Error {
  // eslint-disable-next-line unicorn/custom-error-definition
  public constructor(message?: string) {
    super(message)
    this.name = 'ValidationError'
  }
}
